export default "__VITE_ASSET__6NYh28gQ__"